import React, { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import useAxios from "../utils/useAxios";
import { accessTokenState, refreshTokenState } from "../App";
import jwtDecode from "jwt-decode";
import { IconButton } from "@mui/material";
import { useState } from "react";
import {
  EditOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Input,
  Modal,
  Space,
  Upload,
  Divider,
  Typography,
  AutoComplete,
  DatePicker,
} from "antd";
import { Layout } from "antd";

import dayjs from "dayjs";

import { currentLangState } from "./Dashboard";
import axios from "axios";
import { LocalizationStrings } from "../utils/localization";
import OrdersInputForm from "./forms/OrdersInputForm";

function Orders(props) {
  let api = useAxios();

  const strings = LocalizationStrings;

  const currentLang = useRecoilValue(currentLangState); // Default language is English (en

  strings.setLanguage(currentLang);

  const setAccessToken = useSetRecoilState(accessTokenState);
  const setRefreshToken = useSetRecoilState(refreshTokenState);
  const [Srows, setRows] = useState([]);
  const [editData, setEditData] = useState(null);
  const [inputData, setInputData] = useState(null);
  //   const [usersDropdown, setUsersDropdown] = useState([]);

  const [inputOpen, setInputOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [users, setUsers] = useState([]);
  const [, setShowroomCars] = useState([]);
  const navigate = useNavigate();

  const [search, setSearch] = useState("");

  const newsColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 75,
    },
    {
      title: strings.title,
      dataIndex: "title",
      key: "title",
      width: 200,
      sorter: {
        compare: (a, b) => a.title.localeCompare(b.title),
      },
    },
    {
      title: strings.user,
      dataIndex: "userEmail",
      key: "user.email",
      width: 200,
      sorter: {
        compare: (a, b) => a.user.email.localeCompare(b.user.email),
      },
    },
    {
      title: strings.status,
      dataIndex: "statusDescription",
      key: "statusDescription",
      width: 200,
      sorter: {
        compare: (a, b) =>
          a.statusDescription.localeCompare(b.statusDescription),
      },
    },
    {
      title: strings.infoDate,
      dataIndex: "infoDate",
      key: "infoDate",
      width: 200,
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   key: "description",
    //   width: 100,
    // },

    {
      title: strings.options,
      key: "options",
      dataIndex: "options",
      width: 150,
      render: (text, record, index) => (
        <>
          <IconButton
            key="edit"
            type="primary"
            className="tag-primary"
            onClick={() => {
              //console log this row
              setEditData(record);
              handleUpdateDialogClickOpen(record.id);
            }}
          >
            <EditOutlined />
          </IconButton>
          <IconButton
            key="delete"
            type="primary"
            className="tag-primary"
            onClick={() => {
              setDeleteId(record.id);
              handleDeleteButtonClickRow(record);
            }}
          >
            <DeleteOutlined />
          </IconButton>
          <IconButton
            key="info"
            type="primary"
            className="tag-primary"
            onClick={() => {
              navigate(`/orders/${record.id}`);
            }}
          >
            <InfoCircleOutlined />
          </IconButton>
        </>
      ),
    },
  ];

  let isMounted = true;

  const parseStatusCode = (code) => {
    switch (code) {
      case "047":
        return "Колата е поръчана";
      case "111":
        return "Колата е предвидена за производство";
      case "150":
        return "Колата ще бъде произведена на … шаси:";
      case "165":
        return "Колата се транспортира от Америка - Европа";
      case "182":
        return "Колата се транспортира към склад Австрия";
      case "193":
        return "Колата е доставена в склад Австрия";
      case "195":
        return "Колата се транспортира от склад Австрия към Б-я";
      case "198":
        return "Колата е доставена в Бова Кар";
      default:
        return "Няма статус";
    }
  };

  const fetchData = async (p, isSearchEmpty = false) => {
    try {
      if (isMounted) {
        // console.log(headerConfig);
        const response = await api.get(`/admin/orders`, {
          params: {
            page: p,
            limit: 10,
            search: isSearchEmpty ? null : search,
            sortBy: "createdAt:DESC",
          },
        });
        console.log(response);
        setTotal(response.data.data.meta.totalItems);
        var data = [];
        for (let i = 0; i < response.data.data.data.length; i++) {
          data.push(response.data.data.data[i]);
          data[i].userEmail = data[i].user.email;
          //add key element to each row
          data[i].key = i;
          data[i].createdAt = dayjs(data[i].createdAt).format(
            "DD/MM/YYYY HH:mm:ss"
          );
          data[i].infoDate = data[i].infoDate
            ? dayjs(data[i].infoDate).format("DD/MM/YYYY")
            : "";

          data[i].statusDescription = parseStatusCode(data[i].status);
          // console.log("data: " + i + " " + data);
          // setRows([...Srows, ...data]);
        }
        setRows(data);
        // console.log(Srows);

        // console.log("rows1 \n" + rows1);
      }
    } catch (error) {
      console.error(error);
      // props.logOut();
    }
  };

  useEffect(() => {
    const user = jwtDecode(localStorage.getItem("bovaAccessToken"));
    // console.log(user.role);
    if (user.role !== "admin") {
      alert("not admin");
      props.logOut();
      return;
    }
    setAccessToken(localStorage.getItem("bovaAccessToken"));
    setRefreshToken(localStorage.getItem("bovaRefreshToken"));
    // console.log(accessToken);
    if (
      (localStorage.getItem("bovaAccessToken") === "" &&
        localStorage.getItem("bovaRefreshToken") === "") ||
      (localStorage.getItem("bovaAccessToken") === null &&
        localStorage.getItem("bovaRefreshToken") === null)
    ) {
      navigate("/signin");
    }

    fetchData(page);
    return () => (isMounted = false);
  }, [props.baseUrl]);

  const getDataById = async (id) => {
    const response = await api.get(`/admin/orders/${id}`);
    // console.log(response);

    return response.data.data;
  };

  const getUsers = async (event) => {
    const response = await api.get(`/admin/users`, {
      params: {
        search: event,
      },
    });
    // console.log(response);
    setUsers(response.data.data.data);

    return response.data.data.data;
    // return response.data.data;
  };

  const getShowroomCars = async () => {
    const response = await api.get(`/admin/showroom-cars`);
    // console.log(response.data.data.data);
    setShowroomCars(response.data.data.data);
    // return response.data.data;
  };

  const handleUpdateDialogClickOpen = async (id) => {
    // console.log(id);
    let data = await getDataById(id);
    console.log(data);
    setEditData({ ...data, statusDescription: parseStatusCode(data.status) });
    getUsers();
    getShowroomCars();
    setUpdateOpen(true);
  };

  const handleInputDialogClose = () => {
    setInputData({});
    setInputOpen(false);
  };

  const handleUpdateDialogClose = () => {
    setEditData({});
    setUpdateOpen(false);
  };

  const handleDeleteButtonClickRow = (cellValues) => {
    // console.log(event);
    setDeleteId(cellValues.id);
    setDeleteOpen(true);
  };

  const handleDeleteDialogCancel = () => {
    setDeleteOpen(false);
  };

  const handleDeleteDialogConfirm = async () => {
    setDeleteOpen(false);
    const response = await api.delete(`/admin/orders/${deleteId}`);
    console.log(response);
    if (response.status === 200) {
      props.openNotification(
        "topRight",
        strings.success,
        strings.order + strings.deletedSuccessfullyF
      );
    }

    fetchData(page);
  };

  return (
    <div
      style={{
        width: 1000,
      }}
    >
      <div>
        <Layout
          style={{
            minHeight: "100vh",
            //set a width to the layout
            width: "115%",
          }}
        >
          <div className="tabled">
            <Row gutter={[24, 0]}>
              <Col xs="24" xl={24}>
                <Card
                  bordered={false}
                  className="criclebox tablespace mb-24"
                  title={strings.orders}
                  extra={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Input
                        placeholder={strings.search}
                        prefix={<SearchOutlined />}
                        size="small"
                        style={{
                          marginRight: 25,
                        }}
                        onPressEnter={(event) => {
                          setSearch(event.target.value);
                          fetchData(page);
                        }}
                        onChange={(event) => {
                          setSearch(event.currentTarget.value);
                          if (event.target.value === "" || null) {
                            setSearch(null);
                            fetchData(page, true);
                          }
                        }}
                        value={search}
                      />
                      <Button
                        onClick={() => {
                          getUsers();
                          getShowroomCars();
                          setInputOpen(true);
                        }}
                      >
                        {strings.create}
                      </Button>
                    </div>
                  }
                >
                  <div className="table-responsive">
                    <Table
                      columns={newsColumns}
                      dataSource={Srows}
                      className="ant-border-space"
                      pagination={{
                        pageSize: 10,
                        current: page,
                        //set number of pages
                        total: total,
                      }}
                      onChange={(pagination) => {
                        setPage(pagination.current);
                        console.log(pagination.current);
                        fetchData(pagination.current);
                      }}
                      size="large"
                    />
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </Layout>
      </div>

      <Modal
        title={strings.create}
        open={inputOpen}
        footer={null}
        onCancel={handleInputDialogClose}
        inputData={inputData}
        width={600}
      >
        <OrdersInputForm
          openNotification={props.openNotification}
          fetchData={fetchData}
          page={page}
          open={[inputOpen, setInputOpen]}
          edit={false}
        />
      </Modal>
      {/* //Edit Input */}
      <Modal
        title={strings.edit}
        open={updateOpen}
        footer={null}
        onCancel={handleUpdateDialogClose}
        width={600}
      >
        <OrdersInputForm
          openNotification={props.openNotification}
          fetchData={fetchData}
          page={page}
          open={[updateOpen, setUpdateOpen]}
          edit={true}
          id={editData?.id}
        />
      </Modal>

      <Modal
        title="Are you sure you want to delete the item?"
        open={deleteOpen}
        onOk={handleDeleteDialogConfirm}
        onCancel={handleDeleteDialogCancel}
      ></Modal>
    </div>
  );
}

export default Orders;
